import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Schemas
const donationSchema = Yup.object().shape({
  whereToDonate: Yup.string().required(i18n.t('donation.where_required')),
  whereToDonateId: Yup.string().required(i18n.t('donation.where_required')),
  amount: Yup.string().required(i18n.t('donation.amount_required')),
  giftType: Yup.string().required(),
  giftRecurringOption: Yup.string().nullable().optional(),
  date: Yup.string().required(i18n.t('donation.start_date_required')),
  optMonthlyUpdates: Yup.boolean().nullable().optional().default(null),
  notes: Yup.string()
    .nullable()
    .optional()
    .when('$isIcac', {
      is: true,
      then: (schema) => schema.required(i18n.t('donation.state_required')),
      otherwise: (schema) => schema.nullable().optional()
    })
});

const editSubscriptionSchema = Yup.object().shape({
  amount: Yup.string().required(i18n.t('donation.amount_required')),
  dueDate: Yup.string().required(i18n.t('donation.due_date_required')),
  giftRecurringOption: Yup.string(),
  key: Yup.string()
});

// Types
export type DonationData = Yup.InferType<typeof donationSchema>;
export type EditSubscriptionData = Yup.InferType<typeof editSubscriptionSchema>;

// Resolvers
export const donationResolver = yupResolver(donationSchema);
export const editSubscriptionResolver = yupResolver(editSubscriptionSchema);
